var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}],attrs:{"data-transfer":_vm.transfer}},[_c('transition',{attrs:{"name":"toast"},on:{"after-leave":_vm.animationEnd}},[(_vm.visible)?_c('div',{class:_vm.toastClasses,domProps:{"innerHTML":_vm._s(_vm.message)}},[_c('div',{class:_vm.prefixCls+'-bg'}),_vm._v(" "),_vm._t("default")],2):_vm._e()])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/toast/toast.vue